import {
  ID,
  SortingMode,
  Task,
  TaskListTreeItem,
  Timestamp,
  WeekDays,
} from '@griply/types';
import { buildDeadlineDeadlineTree } from '@griply/utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type Options = {
  tasks: Task[];
  customOrder?: Record<ID, ID[]>;
  sortingMode?: SortingMode | null;
  today: Timestamp;
  weekStartsOn: WeekDays;
  showEmptyGroups?: boolean;
  hideNewTaskRow?: boolean;
};

export const useDeadlineDeadlineTree = ({
  tasks,
  customOrder,
  sortingMode,
  today,
  weekStartsOn,
  showEmptyGroups,
  hideNewTaskRow,
}: Options) => {
  const { t } = useTranslation();
  const overdueLabel = t('general.sections.overdue.title');
  const noDeadlineLabel = t('general.labels.no-deadline');

  return useMemo<Record<ID, TaskListTreeItem>>(
    () =>
      buildDeadlineDeadlineTree({
        tasks,
        customOrder,
        sortingMode,
        today,
        weekStartsOn,
        showEmptyGroups,
        hideNewTaskRow,
        overdueLabel,
        noDeadlineLabel,
        rootLabel: 'Root',
        newTaskLabel: 'New Task',
      }),
    [
      customOrder,
      sortingMode,
      tasks,
      today,
      weekStartsOn,
      showEmptyGroups,
      hideNewTaskRow,
      overdueLabel,
      noDeadlineLabel,
    ],
  );
};
